import PropTypes from 'prop-types';

const brandCard = PropTypes.shape({
    title: PropTypes.string.isRequired,
    retailersAmount: PropTypes.number.isRequired,
    to: PropTypes.string.isRequired,
    availableCountries: PropTypes.arrayOf(PropTypes.string),
});

const brandCardList = PropTypes.arrayOf(brandCard);

export default { brandCard, brandCardList };
